<template>
<div class="chapter">
<div class="inner_page">
<p class="epi"><a id="page_vii">I, [name], having been appointed an officer in the United Federation of Planets as indicated in the grade of captain, do solemnly swear to uphold the regulations of the United Federation Starfleet as well as the laws of the United Federation of Planets: to represent the highest ideals for which they stand, to become an ambassador of peace and goodwill, to protect the security of the Federation and its member worlds, and to offer aid to any and all beings that request it.</a></p><a id="page_vii">
</a><p class="epi-att"><a id="page_vii">—Starfleet Oath of Service</a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?81e9512a